import { gql } from '@apollo/client/core';

const DestroyWarRoomRatingMutation = gql`
  mutation destroyWarRoomRating($input: DestroyRatingInput!) {
    destroyRating(input: $input) {
      reactable {
        ... on Comment {
          totalRating
          currentUserRating {
            value
          }
        }
      }
    }
  }
`;

export default DestroyWarRoomRatingMutation;
